import { render, staticRenderFns } from "./FoodVoucherModal.vue?vue&type=template&id=2b5acba0&scoped=true&style=top%3A%2020px"
import script from "./FoodVoucherModal.vue?vue&type=script&lang=ts"
export * from "./FoodVoucherModal.vue?vue&type=script&lang=ts"
import style0 from "./FoodVoucherModal.vue?vue&type=style&index=0&id=2b5acba0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5acba0",
  null
  
)

export default component.exports